(function () {
    'use strict';

    angular
        .module('iMatApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$scope', '$window', '_', 'workflow', 'workspace', 'guard', 'eventService','multipleUploadTrackEventsService',
        'generalErrorHandler', 'multipleUploadStateManager'];
    function MainController($scope, $window, _, workflow, workspace, guard, eventService, trackEventsService, generalErrorHandler, stateManager) {
        var vm = this;

        vm.workspace = workspace;
        vm.generalError = null;
        vm.knobOptions = { unit: '%', readOnly: true, size: 100, trackWidth: 5, barWidth: 5 };
        vm.showPreviewPopup = showPreviewPopup;

        vm.closeErrorPopup = closeErrorPopup;

        vm.areAllModelsCreated = areAllModelsCreated;

        eventService.subscribe($scope, 'CancelProductProcessing', cancelProductProcessing);
        eventService.subscribe($scope, 'AcceptRepair', acceptRepair);
        eventService.subscribe($scope, 'DeclineRepair', declineRepair);
        eventService.subscribe($scope, 'RefreshProduct', refreshProduct);
        eventService.subscribe($scope, 'generalError', handleGeneralError);
        eventService.subscribe($scope, 'clearGeneralError', clearGeneralError);

        activate();

        // -----------------------------------------------------------------------------------

        function activate() {
            workflow.init();
            stateManager.setup($scope);
        }

        function showPreviewPopup(model) {
            eventService.notify('ShowPreviewInPopup', model);
        }

        function closeErrorPopup() {
            clearGeneralError();
        }

        function areAllModelsCreated() {
            return _.every(vm.workspace.products, function (product) {
                return angular.isDefined(product.model.id);
            });
        }

        // ----------------------------------- Private functions -----------------------------

        function cancelProductProcessing(product) {
            workflow.cancelProductProcessing(product.id);
        }

        function acceptRepair(product) {
            trackEventsService.trackAcceptDeclineV3RepairResults(true);

            workflow.acceptRepair(product.id);
        }

        function declineRepair(product) {
            trackEventsService.trackAcceptDeclineV3RepairResults(false);

            workflow.declineRepair(product.id);
        }

        function refreshProduct(product) {
            workflow.refreshProduct(product.id);
        }

        function handleGeneralError(reason) {
            vm.generalError = generalErrorHandler.handle(reason);
        }

        function clearGeneralError() {
            vm.generalError = null;
        }
    }
})();